module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-72x72-883de72922ee096a8dc41dac6cdedb1f.png";